import { MonitoringErrorDetails } from "../../../domain/monitoring/monitoringErrorDetails";
import moment from "moment";
import { IMonitoringErrorsRepository } from "../../../domain/monitoring/i-monitoring-errors-repository";
import { MonitoringAvailabilityZoneInfo } from "../status/monitoring-status.view-model";
import { Channel } from "../../../domain/channel";
import { UserService } from "../../../domain/user-service";
import { ChannelRepository } from "../../../domain/channel-repository";

export class MonitoringEventLogViewModel {
  public selectedAvailabilityZoneIds: number[] = [];
  public selectedErrorTypesIds: number[] = [];
  public allAvailabilityZones: MonitoringAvailabilityZoneInfo[] = [];
  public selectedChannelIds: number[] = [];
  public allChannels: Channel[] = [];
  public visibleChannels: Channel[] = [];
  public errors: MonitoringErrorDetails[] = [];
  public selectedFromDate: moment.Moment;
  public selectedToDate: moment.Moment;
  constructor(
    private _monitoringErrorsRepository: IMonitoringErrorsRepository,
    private _userService: UserService,
    private _channelRepository: ChannelRepository,
  ) {}

  async onInit() {
    this.selectedFromDate = moment().tz("UTC");
    this.selectedToDate = moment().tz("UTC").add(1, "days");

    this.allAvailabilityZones = this._userService
      .getCurrentUser()
      .channelAvailabilityZones.filter((z) => z.isActive)
      .map(
        (z) =>
          new MonitoringAvailabilityZoneInfo(z.id, z.displayName, z.htmlColor),
      );
    this.allChannels = (
      await this._channelRepository.getAllChannels(null, true)
    ).sort((a, b) => this._sortByAlphabet(a.name, b.name));
  }
  public onAvailabilityZoneChanged() {
    this.visibleChannels = this.allChannels.filter(
      this._checkIfChannelBelongsToAZ.bind(this),
    );
    //refresh the table
  }
  public async refreshButtonClicked() {
    await this.refreshAlertsState();
  }

  private _checkIfChannelBelongsToAZ(channel: Channel): boolean {
    for (let i = 0; i < channel._availabilityZoneIds.length; i++) {
      const channelAZId = channel._availabilityZoneIds[i];
      if (this.selectedAvailabilityZoneIds.includes(channelAZId)) {
        return true;
      }
    }

    return false;
  }

  async refreshAlertsState() {
    const errors = await this._getErrors();

    this.errors = errors.sort((a, b) =>
      this._sortByTimeDesc(a.createdTime, b.createdTime),
    );
  }

  formatTime(time: moment.Moment) {
    return time.format("DD/MM/YYYY HH:mm:ss.SSS");
  }

  private _getErrors(): Promise<MonitoringErrorDetails[]> {
    let errorIds = null;
    if (this.selectedErrorTypesIds && this.selectedErrorTypesIds.length > 0) {
      errorIds = [...this.selectedErrorTypesIds];
    }
    let channelIds = null;
    if (this.selectedChannelIds && this.selectedChannelIds.length > 0) {
      channelIds = [...this.selectedChannelIds];
    }
    let availabilityZoneIds = null;
    if (
      this.selectedAvailabilityZoneIds &&
      this.selectedAvailabilityZoneIds.length > 0
    ) {
      availabilityZoneIds = [...this.selectedAvailabilityZoneIds];
    }

    return this._monitoringErrorsRepository.get(
      availabilityZoneIds,
      errorIds,
      channelIds,
      this.selectedFromDate,
      this.selectedToDate,
      false,
    );
  }

  private _sortByTimeDesc(a: moment.Moment, b: moment.Moment) {
    let result = 0;
    if (a.isBefore(b)) {
      result = 1;
    } else if (a.isAfter(b)) {
      result = -1;
    }

    return result;
  }

  private _sortByAlphabet(a, b) {
    let result = 0;
    result = a.localeCompare(b);

    return result;
  }

  public static LastState: MonitoringEventLogViewModel;
}
